<template>
  <div 
    ref="parallaxElement"
    :class="className"
    :style="parallaxStyle"
  ></div>
</template>

<script>
import { ref, onMounted, onUnmounted, computed } from 'vue'

export default {
  name: 'ParallaxComponent',
  props: {
    offset: {
      type: Number,
      default: 0
    },
    speed: {
      type: Number,
      default: 0.5
    },
    bgImage: {
      type: String,
      required: true
    },
    strength: {
      type: Number,
      default: 100
    },
    className: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const parallaxElement = ref(null)
    const scrollY = ref(0)

    const parallaxStyle = computed(() => {
      // const yPos = -(scrollY.value * props.speed)
      return {
        backgroundImage: `url(${props.bgImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: `center 0px`,
        backgroundSize: 'contain',
        willChange: 'background-position'
      }
    })

    const handleScroll = () => {
      if (parallaxElement.value) {
        const rect = parallaxElement.value.getBoundingClientRect()
        const elementTop = rect.top + window.pageYOffset
        const windowHeight = window.innerHeight
        
        // Calculate if element is in viewport
        const isInView = rect.top < windowHeight && rect.bottom > 0
        
        if (isInView) {
          scrollY.value = window.pageYOffset - elementTop + props.offset
        }
      }
    }

    onMounted(() => {
      window.addEventListener('scroll', handleScroll, { passive: true })
      handleScroll() // Initial call
    })

    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll)
    })

    return {
      parallaxElement,
      parallaxStyle
    }
  }
}
</script>
